import React from 'react';
import { Check, Cloud, Loader2 } from 'lucide-react';

/**
 * AutoSaveIndicator — the small "Saved / Changes save automatically" badge
 * that lives in the top-right `actions` slot of `TabPageLayout`.
 *
 * State machine:
 *   saving → spinner + "Saving…"
 *   savedFlash → green check + "Saved" (caller controls flash timing)
 *   default → gray cloud + "Changes save automatically"
 */
const AutoSaveIndicator = ({ saving = false, savedFlash = false, error = null }) => {
  let icon;
  let label;
  let colorClass = 'text-gray-400';

  if (error) {
    label = error;
    colorClass = 'text-red-600';
    icon = <Cloud className="w-4 h-4" />;
  } else if (saving) {
    label = 'Saving…';
    colorClass = 'text-blue-500';
    icon = <Loader2 className="w-4 h-4 animate-spin" />;
  } else if (savedFlash) {
    label = 'Saved';
    colorClass = 'text-emerald-600';
    icon = <Check className="w-4 h-4" />;
  } else {
    label = 'Changes save automatically';
    icon = <Cloud className="w-4 h-4" />;
  }

  return (
    <div
      data-testid="autosave-indicator"
      className={`hidden sm:inline-flex items-center gap-1.5 text-sm font-medium transition-colors ${colorClass}`}
    >
      {icon}
      {label}
    </div>
  );
};

export default AutoSaveIndicator;
